import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  skillsTitle: {
    color: 'rgba(0, 0, 0, 0.3)',
    textAlign: 'center',
    margin: theme.spacing(2, 0, 2, 0),
    fontAize: '14px',
    lineHeight: '24px',
    verticalAlign: 'middle',
    animation: `${keyframes`
      from {
        opacity: 0;
        transform: translateY(-24px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    `} 0.5s ease-out 0.55s`,
    animationFillMode: 'backwards',
  },
  skills: {
    textAlign: 'center',
    margin: theme.spacing(0, 'auto', 3, 'auto'),
    boxAizing: 'border-box',
    [theme.breakpoints.up('md')]: {
      maxWidth: 'calc(100% - 96px)',
    },
  },
  years: {
    padding: theme.spacing(4, 0),
  },
  placeholder: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
  error: {
    color: 'rgb(244, 67, 54)',
    marginLeft: theme.spacing(1),
  },
  edit: {
    marginTop: `${theme.spacing(-1)} !important`,
    marginBottom: `${theme.spacing(-1)} !important`,
    marginLeft: '0px !important',
    verticalAlign: 'top !important',
  },
  skillsWrapper: {
    marginBottom: theme.spacing(-1),
  },
  sliderControlWrapper: {
    '& > * > *': {
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
  },
}))
